import React from 'react';
import { Users, UserPlus, Search } from 'lucide-react';
import { ComponentHeader } from '../contract-view/ComponentHeader';
import { EmployeeCard } from './EmployeeCard';
import { Employee } from '../../../types/employee';

interface EmployeesListProps {
  employees: Employee[];
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onAddEmployee: () => void;
  getStatusColor: (status: string) => string;
  getStatusLabel: (status: string) => string;
}

export const EmployeesList: React.FC<EmployeesListProps> = ({
  employees,
  searchTerm,
  onSearchChange,
  onAddEmployee,
  getStatusColor,
  getStatusLabel,
}) => {
  return (
    <div className="w-full space-y-4">
      {/* Lista de Funcionários */}
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
        {/* Header da Lista com Busca */}
        <ComponentHeader
          title="Funcionários"
          subtitle={`${employees.length} funcionário${employees.length !== 1 ? 's' : ''}`}
          icon={Users}
        >
          <div className="flex items-center gap-3 mt-3">
            {/* Busca */}
            <div className="relative flex-1 max-w-md">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-white/70" />
              <input
                type="text"
                placeholder="Buscar funcionários..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-full pl-10 pr-4 py-2 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-white/50"
              />
            </div>
            
            {/* Botão Adicionar */}
            <button
              onClick={onAddEmployee}
              className="px-4 py-2 bg-white/20 hover:bg-white/30 text-white rounded-lg transition-colors flex items-center gap-2 border border-white/30"
            >
              <UserPlus className="w-4 h-4" />
              Adicionar
            </button>
          </div>
        </ComponentHeader>
        
        <div className="p-4">
          {employees.length === 0 ? (
            <div className="text-center py-8">
              <button
                onClick={onAddEmployee}
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-white bg-primary hover:bg-primary-dark rounded-lg transition-colors"
              >
                <UserPlus className="w-4 h-4" />
                Adicionar Funcionário
              </button>
            </div>
          ) : (
            <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 auto-rows-fr">
              {employees.map((employee) => (
                <EmployeeCard
                  key={employee.id}
                  employee={employee}
                  getStatusColor={getStatusColor}
                  getStatusLabel={getStatusLabel}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
